import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import notificationCongratulations from "../../../../Assets/Images/notificationDropdownModal.PNG";
import "./NotificationDropdownModal.css";

const NotificationDropdownModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="notificationDropdownModal1"
      centered
    >
      <Modal.Body className="modal-bg-image">
        <div onClick={props.onHide} className="d-flex justify-content-end">
          <div className="closeNotificationDrop text-center">X</div>
        </div>

        <div className="d-flex justify-content-center align-items-center">
          <div className="text-center p-5">
            <img
              src={notificationCongratulations}
              className="img-fluid border-0"
              alt=""
            />
            <div>
              <h1 className="text-white">Congratulations! 🥳 </h1>
              <h2 className="text-warning">Shakib Al Hasan Responded</h2>

              <div className="text-muted mt-4">
                <p>Please Register before 20 December</p>
                <p>To get your desired wish from Shakib Al Hasan</p>
              </div>
            </div>
            <Link to="/starProfile/user-greetings-pay">
              <button className="btn btn-warning w-50 mt-3">
                Register Now
              </button>
            </Link>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NotificationDropdownModal;
